import { render, staticRenderFns } from "./DoctorAccountInfo.vue?vue&type=template&id=04424e56"
import script from "./DoctorAccountInfo.vue?vue&type=script&lang=js"
export * from "./DoctorAccountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports